<template>
	<v-sheet flat>
        <render-content id="researchpolicies"></render-content>
        
	</v-sheet>
</template>

<script>
  import RenderContent from "@c/ui/RenderContent"
  export default {
    name: 'Support',
    components: {
      RenderContent
    },
  }
</script>
